import {DialogTypes, ActionSheetDir, PopupDir} from '../enum'
import PickerComponent from '../components/container/dialog/picker/Index.vue'

export default class Dialog{
	constructor({component, props, value = ''} = {}) {
		this.id = 'dialog_' + Math.random()
	    this.component = component
		this.props = props
		this.value = value
	}
}

class Toast{
	constructor(props = {}) {
		this.type = DialogTypes.TOAST
		this.message = props.message || ''
		this.icon = props.icon || ''
		this.time = props.time || 2 * 1000
	}
}

class Alert{
	constructor(props = {}) {
		this.type = DialogTypes.ALERT
		this.title = props.title || ''
		this.message = props.message || ''
		this.handler = props.handler
	}
}

class Confirm{
	constructor(props = {}) {
		this.type = DialogTypes.CONFIRM
		this.title = props.title || ''
		this.message = props.message || ''
		this.confirm = props.confirm
		this.cancel = props.cancel
		this.confirmText = props.confirmText
	}
}

/** ActionSheet弹出层 **/
class ActionSheet{
	constructor(props = {}) {
		this.type = DialogTypes.ACTIONSHEET
		this.buttons = props.buttons || []
		this.cancel = props.cancel
		this.dir = props.dir || ActionSheetDir.BOTTOM
	}
}

class ActionSheetButton{
	constructor({text = '', handler}) {
	    this.text = text
		this.handler = handler
	}
}

class Popup{
	constructor({component, on = {}, dir = PopupDir.TOP, value = '', height = '90%', width = '100%', cancel = true, title = '', handler} = {}) {
	    this.component = component
		this.eventListener = on
		this.dir = dir
		this.height = height
		this.width = width
		this.cancel = cancel
		this.title = title
		this.value = value
		this.handler = handler
	}
}

class Picker{
	constructor({component, props = {}, on = {}, value = '', cancel = true, title = '请选择', handler} = {}) {
		this.type = 'normal'
	    this.component = PickerComponent
		this.props = {
			...props,
			value
		}
		this.eventListener = on
		this.dir = PopupDir.TOP
		this.height = '60%'
		this.width = '100%'
		this.cancel = cancel
		this.title = title
		this.handler = handler
	}
}

export {
	Toast,
	Alert,
	ActionSheet,
	ActionSheetButton,
	Popup,
	Picker
}